const ENV_PRODUCCION = true //cambiar a false para desarrollo

const API_URL = () => {
  return ENV_PRODUCCION ?  "https://elecciones.ulagos.cl/" : "http://localhost:80/"

}

export {API_URL}